import Vue from 'vue'
import {postBlob} from "@/plugins/axios";

export function getUserList(data) {
    return Vue.axios({
        url: '/api/users/list',
        method: 'post',
        params: {...data}
    })
}

export function getUserOption(data) {
    return Vue.axios({
        url: '/api/users/option',
        method: 'get',
        params: {...data}
    })
}

export function getDeletedList(data) {
    return Vue.axios({
        url: '/api/users/deletedList',
        method: 'get',
        params: {...data}
    })
}

export function getUserDetail(id) {
    return Vue.axios({
        url: '/api/users/detail',
        method: 'get',
        params: {id}
    })
}

// 我的基本信息
export function myBaseInfo() {
    return Vue.axios({
        url: '/api/users/myBaseInfo',
        method: 'get',
        params: {}
    })
}

// 我的第三方绑定情况（钉钉 / 飞书）
export function myThirdPartyBindings() {
    return Vue.axios({
        url: '/api/users/myThirdPartyBindings',
        method: 'get',
        params: {}
    })
}

export function getRoleList() {
    return Vue.axios({
        url: '/api/users/roleList',
        method: 'get',
        params: {}
    })
}

export function addOrEditUser(data) {
    return Vue.axios({
        url: '/api/users/store',
        method: 'post',
        data: {...data}
    })
}

export function deleteUser(id) {
    return Vue.axios({
        url: '/api/users/delete',
        method: 'get',
        params: {id}
    })
}

export function undoDelete(id) {
    return Vue.axios({
        url: '/api/users/undoDelete',
        method: 'get',
        params: {id}
    })
}

//重置密码
export function updatePassword(data) {
    return Vue.axios({
        url: '/api/users/passwordReset',
        method: 'post',
        data: {...data}
    })
}

// 修改密码

export function changePassword(data) {
    return Vue.axios({
        url: '/api/users/passwordRequest',
        method: 'post',
        data: {...data}
    })
}

export function uploadFile(data) {
    return Vue.axios({
        url: '/api/upload/import',
        method: 'post',
        data: {...data}
    })
}


export function updateInfo(data) {
    return Vue.axios({
        url: '/api/users/update',
        method: 'post',
        data: {...data}
    })
}

/**
 *
 * @param {*} data
 * @param {String} data.type value:order:订单，customer:客户，artisan：红人
 * @param {Array} data.fields 缓存字段
 */
export function updateTableDisplay(data) {
    return Vue.axios({
        url: '/api/cache/tableShowFields',
        method: 'post',
        data: {...data}
    })
}

export function saleOptions(data) {
    return Vue.axios({
        url: '/api/users/saleOptions',
        method: 'get',
        params: {...data}
    })
}

export function userSearch(data) {
    return Vue.axios({
        url: '/api/users/search',
        method: 'post',
        data: {...data}
    })
}

//根据角色获取用户列表
export function getUserByRole(data) {
    return Vue.axios({
        url: '/api/users/userRole',
        method: 'get',
        params: {...data}
    })
}

/**
 * 在线用户列表
 * @param data
 * @returns {*}
 */
export function getUseOnlineList(data) {
    return Vue.axios({
        url: '/api/user_online/list',
        method: 'get',
        params: {...data}
    })
}

/**
 * 用户权限列表查询
 * @param data
 * @returns {*}
 */
export function getUserPurviewList(data) {
    return Vue.axios({
        url: '/api/users/getUserPurview',
        method: 'get',
        params: {...data}
    })
}

/**
 * 用户权限列表查询
 * @param data
 * @returns {*}
 */
export function exportUserPurview(data) {
    return postBlob('/api/users/exportUserPurview', data)

}
